// Imports
import AxiosConfig from './serverAxiosConfig'
import firebase from '../config/FirebaseConfig'

const createCheckout = async (priceId, addOn, isSale) => {
  const { Aa: token } = firebase.auth().currentUser

  const payload = {
    priceId,
    addOn,
    firstMonthSale: isSale
  }
  const { data } = await AxiosConfig.post(
    '/subscription/checkout-session',
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const createBillingPortalLink = async () => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get(
    '/subscription/manage-session',
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const changeSubscription = async (priceId, addOn) => {
  const { Aa: token } = firebase.auth().currentUser

  const payload = {
    priceId,
    addOn
  }
  const { data } = await AxiosConfig.post(
    '/subscription/change-subscription',
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const createTrialSubscription = async (payload) => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.post(
    '/subscription/create-trial',
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const createSetupIntent = async () => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.post(
    '/subscription/create-setup-intent',
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const applyCoupon = async (coupon, priceId) => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.post(
    '/subscription/validate-coupon',
    { coupon, priceId },
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const createAPISubscription = async (payload) => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.post(
    '/subscription/api',
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const updateTeamSeats = async (newTeamCount) => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.post(
    '/subscription/update-team-seats',
    { newTeamCount },
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const updateLensLimit = async (newLensLimit) => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.post(
    '/subscription/update-lens-limit',
    { newLensLimit },
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const createSpyderSubscription = async (payload) => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.post(
    '/subscription/add-spyder',
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const cancelSpyderSubscription = async (subscriptionId) => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.post(
    '/subscription/cancel-spyder',
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const updatePaymentMethod = async (paymentMethodId, customerId) => {
  const token = await firebase.auth().currentUser.getIdToken()

  const { data } = await AxiosConfig.post(
    '/subscription/update-payment-method',
    { paymentMethodId, customerId },
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const getSubscriptionInvoices = async () => {
  const user = firebase.auth().currentUser
  const authToken = await user.getIdToken()

  const { data } = await AxiosConfig.get('/subscription/invoices', {
    headers: {
      Authorization: `Bearer ${authToken}`
    }
  })

  return data
}

// operation: 'resume' | plan: 'base' | 'api'
const manageSubscription = async (operation, plan) => {
  const user = firebase.auth().currentUser
  if (!user) throw new Error('User not authenticated')

  const token = await user.getIdToken()

  const { data } = await AxiosConfig.post(
    '/subscription/manage',
    { operation, plan },
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const checkUserSubscription = async (userId, teamId) => {
  const query = new URLSearchParams()
  if (userId) query.append('userId', userId)
  if (teamId) query.append('teamId', teamId)

  const { data } = await AxiosConfig.get(`/subscription/check?${query.toString()}`)

  return data
}

export default {
  createCheckout,
  createBillingPortalLink,
  changeSubscription,
  createTrialSubscription,
  createSetupIntent,
  applyCoupon,
  createAPISubscription,
  updateLensLimit,
  updateTeamSeats,
  createSpyderSubscription,
  cancelSpyderSubscription,
  updatePaymentMethod,
  getSubscriptionInvoices,
  checkUserSubscription,
  manageSubscription
}
